"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaymentCard = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Payment card displayed for example in OOB order detail.
 * @param props PaypentProps
 * @returns JSX.Element
 */

const PaymentCard = ({
  className,
  sectionHeader,
  sectionDecription,
  paymentProviders,
  testId,
  activeProviderId,
  setActiveProviderId
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
  className: className,
  "data-test-id": testId,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    variant: "h5",
    children: sectionHeader
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Description, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Lock, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      children: sectionDecription
    })]
  }), paymentProviders.map(provider => {
    const {
      name,
      blockReason,
      imageUrl,
      paymentProviderId
    } = provider;
    const isActive = paymentProviderId === activeProviderId;
    const ownerState = {
      isActive
    };
    const isBlocked = blockReason !== null;
    const activatePaymentProvider = () => {
      if (!isActive && !isBlocked) {
        setActiveProviderId(paymentProviderId);
      }
    };
    if (isBlocked) {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PaymentProviderBox, {
      ownerState: ownerState,
      "aria-checked": isActive,
      role: "checkbox",
      "data-payment-provider-id": paymentProviderId,
      onClick: activatePaymentProvider,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PaymentHeader, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: isActive ? /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: name
          }) : name
        }), imageUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LazyImageTopIcon, {
          src: imageUrl,
          loading: "eager"
        }) : null]
      })
    }, paymentProviderId);
  })]
});
exports.PaymentCard = PaymentCard;
var _default = exports.default = PaymentCard;
